import { Button, FormGroup, Spinner } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import useLogin from '../../../hooks/useLogin';
import { IAuthenticationActionCreators } from '../../../store/redux/Authentication';
import * as AuthenticationStore from '../../../store/redux/Authentication';

const MSLogin = (props: IMSLoginProps) => {
  const { t } = useTranslation('translation');
  const { login, errorMessage, state } = useLogin(props.setLoginState, props.authenticationState);
  const printableErrorMessage: string = t(errorMessage);

  return (
    <>
      {!!errorMessage && <div className="error-message">{printableErrorMessage}</div>}
      <FormGroup className="loginContainer">
        {state == 'IDLE' && (
          <Button className="col-12 btn-primary" onClick={login}>
            {t('login.LOGIN_WITH_MS')}
          </Button>
        )}
        {(state == 'ACQUIRING_MS_TOKEN' || state == 'DOING_FINAL_LOGIN') && (
          <h1 className="login-indicator-container">
            <Spinner className="login-indicator"></Spinner>
            {t('login.LOGGING_IN_MS')}...
          </h1>
        )}
      </FormGroup>
    </>
  );
};

export type IMSLoginProps = IAuthenticationActionCreators & {
  authenticationState?: AuthenticationStore.UserState;
};

export default MSLogin;
